import script from "./SiteBannerSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteBannerSetup.vue?vue&type=script&setup=true&lang=js"

import "./SiteBannerSetup.vue?vue&type=style&index=0&id=4f069ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f069ec0"]])

export default __exports__